import { sellerDetailOrders } from "./sellerDetailOrdersMock";

// Seller detail mock data
export const sellerDetailData: Record<string, any> = {
  kpis: {
    totalProducts: { value: 5234, delta: "+2.1%" },
    activeOrders: { value: 234, delta: "+12.3%" },
    ordersToday: { value: 18, delta: "+5.9%" },
    revenue30d: { value: 18920, delta: "+8.4%" },
    inventoryAlerts: { value: 8, delta: "-25%" },
    syncFailures: { value: 1, delta: "-50%" },
    refundRate: { value: 2.3, delta: "-0.4%" },
    avgFulfillment: { value: "1.8d", delta: "-0.2d" },
  },

  revenueMonthly: [
    { month: "Aug", revenue: 12400, refunds: 320 },
    { month: "Sep", revenue: 14200, refunds: 410 },
    { month: "Oct", revenue: 13800, refunds: 280 },
    { month: "Nov", revenue: 16500, refunds: 520 },
    { month: "Dec", revenue: 21200, refunds: 680 },
    { month: "Jan", revenue: 18920, refunds: 390 },
  ],

  marketplaceRevenue: [
    { marketplace: "Amazon", revenue: 9800, pct: 52 },
    { marketplace: "Flipkart", revenue: 6400, pct: 34 },
    { marketplace: "Meesho", revenue: 2720, pct: 14 },
  ],

  orders: sellerDetailOrders,

  inventory: [
    {
      sku: "SKU-TV-001",
      name: "Wireless Earbuds Pro",
      stock: 234,
      lowThreshold: 50,
      lastSync: "2026-01-09T14:30:00Z",
      status: "OK",
    },
    {
      sku: "SKU-TV-002",
      name: "USB-C Hub 7-in-1",
      stock: 12,
      lowThreshold: 30,
      lastSync: "2026-01-09T14:30:00Z",
      status: "LOW",
    },
    {
      sku: "SKU-TV-003",
      name: "Laptop Stand Aluminum",
      stock: 89,
      lowThreshold: 20,
      lastSync: "2026-01-09T14:30:00Z",
      status: "OK",
    },
    {
      sku: "SKU-TV-004",
      name: "Mechanical Keyboard",
      stock: 5,
      lowThreshold: 15,
      lastSync: "2026-01-09T12:00:00Z",
      status: "CRITICAL",
    },
    {
      sku: "SKU-TV-005",
      name: "Phone Case Bundle",
      stock: 456,
      lowThreshold: 100,
      lastSync: "2026-01-09T14:30:00Z",
      status: "OK",
    },
    {
      sku: "SKU-TV-006",
      name: "Webcam 1080p",
      stock: 0,
      lowThreshold: 10,
      lastSync: "2026-01-08T18:00:00Z",
      status: "OUT",
    },
    {
      sku: "SKU-TV-007",
      name: "Bluetooth Speaker",
      stock: 67,
      lowThreshold: 25,
      lastSync: "2026-01-09T14:30:00Z",
      status: "OK",
    },
    {
      sku: "SKU-TV-008",
      name: "Mouse Pad XL",
      stock: 18,
      lowThreshold: 20,
      lastSync: "2026-01-09T10:00:00Z",
      status: "LOW",
    },
  ],

  catalogSummary: {
    totalSKUs: 5234,
    productTypes: [
      { type: "Electronics", count: 2100 },
      { type: "Accessories", count: 1800 },
      { type: "Cables & Adapters", count: 890 },
      { type: "Cases & Covers", count: 444 },
    ],
    needsMapping: 34,
    recentlyUpdated: 128,
  },

  syncLogs: [
    {
      id: 1,
      marketplace: "Amazon",
      status: "COMPLETED",
      startedAt: "2026-01-09T14:30:00Z",
      duration: "4m 12s",
      products: 3200,
      errors: 0,
    },
    {
      id: 2,
      marketplace: "Flipkart",
      status: "COMPLETED",
      startedAt: "2026-01-09T12:00:00Z",
      duration: "3m 45s",
      products: 1800,
      errors: 2,
    },
    {
      id: 3,
      marketplace: "Meesho",
      status: "FAILED",
      startedAt: "2026-01-09T10:00:00Z",
      duration: "1m 22s",
      products: 0,
      errors: 1,
    },
    {
      id: 4,
      marketplace: "Amazon",
      status: "COMPLETED",
      startedAt: "2026-01-08T14:30:00Z",
      duration: "4m 08s",
      products: 3198,
      errors: 0,
    },
    {
      id: 5,
      marketplace: "Flipkart",
      status: "COMPLETED",
      startedAt: "2026-01-08T12:00:00Z",
      duration: "3m 50s",
      products: 1795,
      errors: 1,
    },
  ],

  notifications: [
    {
      id: 1,
      type: "warning",
      title: "Low stock alert",
      message: "8 SKUs below minimum threshold",
      date: "2026-01-09T15:00:00Z",
      read: false,
    },
    {
      id: 2,
      type: "info",
      title: "Sync completed",
      message: "Amazon catalog sync completed successfully",
      date: "2026-01-09T14:45:00Z",
      read: true,
    },
    {
      id: 3,
      type: "error",
      title: "Sync failed",
      message: "Meesho sync failed — API timeout",
      date: "2026-01-09T10:02:00Z",
      read: false,
    },
    {
      id: 4,
      type: "success",
      title: "Order milestone",
      message: "Crossed 10,000 lifetime orders",
      date: "2026-01-08T09:00:00Z",
      read: true,
    },
    {
      id: 5,
      type: "info",
      title: "Plan renewal",
      message: "Platinum plan renewal due in 15 days",
      date: "2026-01-07T08:00:00Z",
      read: true,
    },
  ],

  activityLog: [
    {
      id: 1,
      action: "Orders processed",
      detail: "18 orders processed today",
      timestamp: "2026-01-09T16:00:00Z",
      icon: "order",
    },
    {
      id: 2,
      action: "Sync completed",
      detail: "Amazon catalog sync — 3,200 products",
      timestamp: "2026-01-09T14:45:00Z",
      icon: "sync",
    },
    {
      id: 3,
      action: "Inventory updated",
      detail: "Bulk stock update for 45 SKUs",
      timestamp: "2026-01-09T11:30:00Z",
      icon: "inventory",
    },
    {
      id: 4,
      action: "Sync failed",
      detail: "Meesho sync — API timeout",
      timestamp: "2026-01-09T10:02:00Z",
      icon: "error",
    },
    {
      id: 5,
      action: "Plan change",
      detail: "Upgraded from Gold to Platinum",
      timestamp: "2026-01-05T09:00:00Z",
      icon: "plan",
    },
    {
      id: 6,
      action: "New marketplace",
      detail: "Connected Meesho marketplace",
      timestamp: "2025-12-20T14:00:00Z",
      icon: "marketplace",
    },
    {
      id: 7,
      action: "Sync completed",
      detail: "Flipkart catalog sync — 1,800 products",
      timestamp: "2025-12-19T12:15:00Z",
      icon: "sync",
    },
  ],
};
